<template>
    <div class="card text-white text-center" :class="backgroundColor" v-if="goDefined">
        <div class="card-body">
            {{ text }}
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            status: {
                type: Object,
                required: true
            },
        },

        computed: {

            text() {
                if (this.status.gonogo == 'go') {
                    return 'GO'
                }
                return 'NO GO'
            },

            backgroundColor() {
                if (!this.goDefined) {
                    return 'bg-gray'
                }
                if (this.status.gonogo == 'go') {
                    return 'bg-success'
                }
                return 'bg-danger'
            },

            goDefined() {
                return this.status.progress_status != 'not-attempted'
            }
        }
    }
</script>
